import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CredentialsSniffer = _resolveComponent("CredentialsSniffer")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CredentialsSniffer, {
      "admin-urls": _ctx.adminUrls,
      timeoutMs: 20000,
      onCredentialsFound: _ctx.handleCredentialsFound,
      onNoCredentialsFound: _ctx.handleNoCredentialsFound
    }, null, 8, ["admin-urls", "onCredentialsFound", "onNoCredentialsFound"]),
    _createVNode(_Transition, { name: "toast" }, {
      default: _withCtx(() => [
        (_ctx.errorMessage)
          ? (_openBlock(), _createBlock(_component_Toast, {
              key: 0,
              message: _ctx.errorMessage,
              variant: _ctx.toastVariant
            }, null, 8, ["message", "variant"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_metainfo, null, {
      title: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content ? `${content} | iCIMS Recorder` : 'iCIMS Recorder'), 1)
      ]),
      _: 1
    }),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: _ctx.modalTitle.title,
          "sub-title": _ctx.modalTitle.subtitle
        }, null, 8, ["title", "sub-title"]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 1,
          "loading-term-value": _ctx.loadingTermValue
        }, null, 8, ["loading-term-value"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (!_ctx.isIframed)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}